import React, { Component } from 'react'
import styled from 'styled-components'

const Inner = styled.div`
background-color: white;
--size: 120px;
width: var(--size);
height: var(--size);
-webkit-clip-path: circle();
display: flex;
justify-content: center;
align-items: center;
`
const ContentContainer = styled.div`
--size: calc(100% / 1.41421356237);
overflow-wrap: break-word;
max-width: var(--size);
max-height: var(--size);
white-space: pre-wrap;
`

class DotView extends Component {

  constructor(props) {
    super(props)
    this.state = { text : "" }
  }

  componentDidMount() {
    this._updateWith(this.props.connectedDot)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this._updateWith(nextProps.connectedDot)
    }
  }

  _updateWith(connectedDot) {
    if (connectedDot !== null) {
      connectedDot.dots[0].text(text => this.setState({ text : text }))
    }
  }

  render() {
    const { text } = this.state
    return <Inner><ContentContainer>{text}</ContentContainer></Inner>
  }
}

export default DotView


// WEBPACK FOOTER //
// ./src/App/View/DotView.js